import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/enter_icon.svg'
import _imports_2 from '@/assets/img/previous-icon.svg'
import _imports_3 from '@/assets/img/next-icon.svg'
import _imports_4 from '@/assets/img/elipse_menu.svg'
import _imports_5 from '@/assets/img/question-icon.svg'
import _imports_6 from '@/assets/img/previous-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-2cd61533"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pros-questions overflow-x-hide overflow-y-hide" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  id: "page-left",
  class: "col-md-11 no-padding container-width"
}
const _hoisted_5 = {
  id: "main-body-before",
  class: "main-body-before"
}
const _hoisted_6 = {
  id: "main-body-sec-qustns",
  class: "row col-sm-12 col-md-12 my-auto no-margin unset-padding"
}
const _hoisted_7 = { class: "row text-container col-xl-12 no-margin no-padding" }
const _hoisted_8 = {
  id: "question-grp-info",
  class: "col-sm-12 col-md-3 flex-container no-padding question-grp-info"
}
const _hoisted_9 = {
  key: 0,
  class: "text-title"
}
const _hoisted_10 = {
  key: 1,
  class: "text-subtitle"
}
const _hoisted_11 = { class: "text-subtitle-line-1" }
const _hoisted_12 = { class: "text-subtitle-line-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "questions-seperator"
}
const _hoisted_15 = {
  key: 0,
  id: "currQstnDiv",
  class: "question-info"
}
const _hoisted_16 = {
  key: 0,
  class: "guidance-text-info"
}
const _hoisted_17 = { class: "guidance-close-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-mr-[2px]",
    src: _imports_0
  })
], -1))
const _hoisted_19 = { class: "guidance-text-block" }
const _hoisted_20 = { class: "guidance-text-content" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 6 }
const _hoisted_27 = { key: 7 }
const _hoisted_28 = { key: 8 }
const _hoisted_29 = { key: 9 }
const _hoisted_30 = { class: "input-container-after" }
const _hoisted_31 = { class: "main-body-after" }
const _hoisted_32 = {
  id: "mb-button-view",
  class: "mb-button-view"
}
const _hoisted_33 = { class: "row footer no-margin" }
const _hoisted_34 = { class: "col-7 col-md-4 footer-panel-container no-padding progress-status-panel" }
const _hoisted_35 = { class: "footer-text" }
const _hoisted_36 = {
  key: 0,
  class: "col-sm-12 col-md-7 no-padding buttons-panel"
}
const _hoisted_37 = { class: "enter-text enter-lg" }
const _hoisted_38 = { class: "enter-text" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "enter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_40 = { class: "mb-nav-icons col-3 no-padding d-block d-md-none" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "right-menu" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "question-icon",
  src: _imports_5
}, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "menu-nav-icons" }
const _hoisted_51 = { class: "previous-img previous-button" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_53 = {
  class: "next-icon",
  src: _imports_3
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "feedbackModalStart",
  type: "button",
  class: "btn btn-primary display-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#feedbackModal"
}, " Feedback Modal Open ", -1))
const _hoisted_55 = {
  id: "feedbackModal",
  class: "modal fade feedback-form",
  "data-bs-backdrop": "false"
}
const _hoisted_56 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "modal-body" }
const _hoisted_61 = { class: "modal-heading" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "modal-text" }
const _hoisted_64 = { class: "text-line-1" }
const _hoisted_65 = { class: "text-line-2" }
const _hoisted_66 = { class: "btn-container" }
const _hoisted_67 = {
  key: 0,
  class: "enter-text"
}
const _hoisted_68 = { class: "enter-text" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "enter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_70 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_71 = { class: "modal-footer-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerlogo = _resolveComponent("headerlogo")!
  const _component_TextBlock = _resolveComponent("TextBlock")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_MultiTile = _resolveComponent("MultiTile")!
  const _component_DropdownSingleLevel = _resolveComponent("DropdownSingleLevel")!
  const _component_SelectSingleLevelMultipleItems = _resolveComponent("SelectSingleLevelMultipleItems")!
  const _component_BubbleTile = _resolveComponent("BubbleTile")!
  const _component_DropdownDoubleLevel = _resolveComponent("DropdownDoubleLevel")!
  const _component_SelectMultiLevel = _resolveComponent("SelectMultiLevel")!
  const _component_radial_progress_bar = _resolveComponent("radial-progress-bar")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_errorhandler = _resolveComponent("errorhandler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_headerlogo, {
            "page-type": '2',
            onSlideMenu: _ctx.slideMenu
          }, null, 8, ["onSlideMenu"]),
          _createElementVNode("div", {
            id: "main-body",
            class: "row no-padding main-body h-100 no-margin",
            style: _normalizeStyle({ height: _ctx.windowHeight })
          }, [
            _createElementVNode("div", {
              id: "main-body-sec",
              class: "main-body-sec",
              style: _normalizeStyle([{ height: _ctx.windowHeightInside }, {"width":"100%"}]),
              onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollSecDiv && _ctx.scrollSecDiv(...args)))
            }, [
              _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
                [_vShow, _ctx.showGradient]
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.currQuestionGroupIndex === 0 || null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.getUiText("app-prospect-questions-heading-1")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.currQuestionGroupInfo || null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.currQuestionGroupInfo.message), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.currQuestionGroupInfo.guidance), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    id: "input-container",
                    class: "col-sm-12 offset-md-1 col-md-7 large-container unset-padding input-container flex-container",
                    style: _normalizeStyle([{ height: _ctx.rightContentHeight }, {"border":"0px solid red"}])
                  }, [
                    _createElementVNode("div", {
                      id: "input-container-before",
                      class: "input-container-before",
                      style: _normalizeStyle(_ctx.inputBeforeGradient)
                    }, null, 4),
                    _createElementVNode("div", {
                      id: "inactive-qstns-block",
                      class: "inactive-qstns-block",
                      style: _normalizeStyle({ 'min-height': _ctx.inactiveMinHeight })
                    }, [
                      (
                          (_ctx.currQuestionGroupInfo.prospect_questions &&
                            _ctx.currQuestionGroupInfo.prospect_questions.length >
                              1) ||
                          null
                        )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currGroupQuestions, (item, itemIndex) => {
                              return (_openBlock(), _createElementBlock("div", { key: itemIndex }, [
                                (item.isAnswered || null)
                                  ? (_openBlock(), _createBlock(_component_TextBlock, {
                                      key: 0,
                                      info: item,
                                      "is-mobile-device": _ctx.isMobileDevice
                                    }, null, 8, ["info", "is-mobile-device"]))
                                  : _createCommentVNode("", true),
                                (
                              (item.isAnswered &&
                                (_ctx.currQuestionInfo.id ||
                                  itemIndex < _ctx.currGroupQuestions.length - 1)) ||
                              null
                            )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 4),
                    (_ctx.currQuestionInfo.id || null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_ctx.canShowGuidance || null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", {
                                  id: "popper-content",
                                  class: _normalizeClass(
                            _ctx.canShowGuidance
                              ? 'popover fade show bs-popover-left'
                              : 'hide'
                          )
                                }, [
                                  _createElementVNode("div", {
                                    class: "guidance-close-panel",
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeGuidanceInfo && _ctx.closeGuidanceInfo(...args)))
                                  }, [
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getUiText("app-prospect-questions-close-info-1")), 1),
                                    _hoisted_18
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.guidanceText), 1)
                                  ])
                                ], 2)
                              ]))
                            : _createCommentVNode("", true),
                          (
                          _ctx.currQuestionInfo.question_display_type === 'text' ||
                          null
                        )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_openBlock(), _createBlock(_component_InputText, {
                                  ref: "INPUT_TEXT",
                                  key: _ctx.currQuestionInfo.id,
                                  info: _ctx.currQuestionInfo
                                }, null, 8, ["info"]))
                              ]))
                            : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'multi-tile'
                        )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (_openBlock(), _createBlock(_component_MultiTile, {
                                    ref: "MULTI_TILE",
                                    key: _ctx.currQuestionInfo.id,
                                    info: _ctx.currQuestionInfo
                                  }, null, 8, ["info"]))
                                ]))
                              : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'single-list-1-search'
                        )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (_openBlock(), _createBlock(_component_DropdownSingleLevel, {
                                      ref: "SELECT_SINGLE_LEVEL",
                                      key: _ctx.currQuestionInfo.id,
                                      info: _ctx.currQuestionInfo,
                                      "enable-search": true
                                    }, null, 8, ["info"]))
                                  ]))
                                : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'multi-list-1-search'
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      (_openBlock(), _createBlock(_component_SelectSingleLevelMultipleItems, {
                                        ref: "SELECT_SINGLE_LEVEL_MULTIPLE",
                                        key: _ctx.currQuestionInfo.id,
                                        info: _ctx.currQuestionInfo,
                                        "enable-search": true
                                      }, null, 8, ["info"]))
                                    ]))
                                  : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'single-bubble'
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        (_openBlock(), _createBlock(_component_BubbleTile, {
                                          ref: "BUBBLE_TILE",
                                          key: _ctx.currQuestionInfo.id,
                                          info: _ctx.currQuestionInfo,
                                          "is-single-select": true
                                        }, null, 8, ["info"]))
                                      ]))
                                    : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'single-list-1'
                        )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                          (_openBlock(), _createBlock(_component_DropdownSingleLevel, {
                                            ref: "SELECT_SINGLE_LEVEL",
                                            key: _ctx.currQuestionInfo.id,
                                            info: _ctx.currQuestionInfo,
                                            "enable-search": false
                                          }, null, 8, ["info"]))
                                        ]))
                                      : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'single-list-2'
                        )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            (_openBlock(), _createBlock(_component_DropdownDoubleLevel, {
                                              ref: "SELECT_SINGLE_LEVEL_2",
                                              key: _ctx.currQuestionInfo.id,
                                              info: _ctx.currQuestionInfo,
                                              "enable-search": false
                                            }, null, 8, ["info"]))
                                          ]))
                                        : (
                          _ctx.currQuestionInfo.question_display_type ===
                          'multi-level-multi-search'
                        )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                              (_openBlock(), _createBlock(_component_SelectMultiLevel, {
                                                ref: "SELECT_MULTI_LEVEL",
                                                key: _ctx.currQuestionInfo.id,
                                                info: _ctx.currQuestionInfo,
                                                "enable-search": true
                                              }, null, 8, ["info"]))
                                            ]))
                                          : (
                          _ctx.currQuestionInfo.question_display_type !== ''
                        )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, " It is : " + _toDisplayString(_ctx.currQuestionInfo.question_display_type), 1))
                                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [
                      [_vShow, _ctx.inputBottomGradient]
                    ])
                  ], 4)
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_31, null, 512), [
                [_vShow, _ctx.showBottomGradient]
              ])
            ], 36),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                class: "btn great-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setNext && _ctx.setNext(...args)))
              }, _toDisplayString(_ctx.getUiText("app-nav-button-next-1")), 1)
            ])
          ], 4),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_radial_progress_bar, {
                class: "d-inline",
                "total-steps": _ctx.totalQuestionGroups,
                "completed-steps": _ctx.currQuestionGroupIndex + 1
              }, null, 8, ["total-steps", "completed-steps"]),
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.getUiText("app-prospect-questions-progress-section-1")) + " " + _toDisplayString(_ctx.currQuestionGroupIndex + 1) + " " + _toDisplayString(_ctx.getUiText("app-prospect-questions-progress-of-1")) + " " + _toDisplayString(_ctx.totalQuestionGroups), 1)
            ]),
            (!_ctx.hideNextPanel || null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn great-btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setNext && _ctx.setNext(...args)))
                    }, _toDisplayString(_ctx.getUiText("app-nav-button-next-1")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.getUiText("app-nav-press-enter-1")), 1),
                    _hoisted_39
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_40, [
              (_ctx.currQuestionGroupIndex > 0 || null)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "mb-prev-icon",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickPrevious && _ctx.onClickPrevious(...args)))
                  }, _hoisted_42))
                : _createCommentVNode("", true),
              (_ctx.currQuestionGroupIndex < _ctx.totalQuestionGroups - 1 || null)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "mb-next-icon",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickSkip && _ctx.onClickSkip(...args)))
                  }, _hoisted_44))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "col-md-1 no-padding menu-width lg-menu-view tw-relative",
          style: _normalizeStyle({ 'min-height': _ctx.dyn_height })
        }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", {
              class: "elipse-menu",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.slideMenu && _ctx.slideMenu(...args)))
            }, _hoisted_47)
          ]),
          _createElementVNode("div", {
            class: "question-icon-panel",
            "data-toggle": "popover",
            title: "",
            "data-content": "",
            "data-placement": "left",
            style: _normalizeStyle({
              'margin-top': _ctx.questionIconTop,
              display: _ctx.canShowGuidanceIcon ? 'block' : 'none',
            }),
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showGuidance && _ctx.showGuidance(...args)))
          }, _hoisted_49, 4),
          _createElementVNode("div", _hoisted_50, [
            (_ctx.currQuestionGroupIndex > 0 || null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(
                _ctx.isTouchDevice ? 'show-prev-image-no-hover' : 'show-prev-image'
              )
                }, [
                  _createElementVNode("img", {
                    class: "prev-img",
                    src: _imports_2,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClickPrevious && _ctx.onClickPrevious(...args)))
                  }),
                  (!_ctx.isTouchDevice || null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onClickPrevious && _ctx.onClickPrevious(...args)))
                      }, [
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createTextVNode(" " + _toDisplayString(_ctx.getUiText("app-prospect-questions-button-previous-1")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "show-next-image",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onClickSkip && _ctx.onClickSkip(...args)))
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_53, null, 512), [
                [_vShow, _ctx.currQuestionGroupIndex < _ctx.totalQuestionGroups - 1]
              ])
            ])
          ])
        ], 4),
        _createVNode(_component_sidebar, {
          "show-menu": _ctx.showMenu,
          onMyResponse: _ctx.myResponse,
          onCreateAccount: _ctx.createAccount,
          onCloseMenu: _ctx.closeMenu
        }, null, 8, ["show-menu", "onMyResponse", "onCreateAccount", "onCloseMenu"])
      ]),
      _hoisted_54
    ]),
    (_ctx.showProspectCallbackError || null)
      ? (_openBlock(), _createBlock(_component_errorhandler, {
          key: 0,
          "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg,
          onResetShowProspectCallbackError: _ctx.resetShowProspectCallbackError
        }, null, 8, ["prospect-callback-error-msg", "onResetShowProspectCallbackError"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_55, [
      _withDirectives(_createElementVNode("div", _mergeProps({ role: "dialog" }, _ctx.$attrs, {
        class: "v-modal",
        style: {"background":"rgba(239, 240, 241, 0.5)","top":"0px"},
        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.feedbackModalNext && _ctx.feedbackModalNext(...args)))
      }), [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.feedbackModalNext && _ctx.feedbackModalNext(...args)))
              }, _hoisted_59)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("p", _hoisted_61, [
                _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-questions-feedback-thanks-text")), 1),
                (_ctx.feedbackModalInfo.name !== '' || null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, ", " + _toDisplayString(_ctx.feedbackModalInfo.name), 1))
                  : _createCommentVNode("", true),
                _createTextVNode("! ")
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.feedbackModalInfo.fd_message), 1),
                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.feedbackModalInfo.fr_message), 1)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn great-btn",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.feedbackModalNext && _ctx.feedbackModalNext(...args)))
                }, _toDisplayString(_ctx.getUiText("app-prospect-questions-feedback-great-text")), 1),
                (!_ctx.isTouchDevice || null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.getUiText("app-nav-press-enter-1")), 1),
                      _hoisted_69
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.feedbackModalInfo.footer_message !== '' || null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.feedbackModalInfo.footer_message), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 16), [
        [_vShow, _ctx.isFeedbackModalOpened]
      ])
    ])
  ]))
}